module.exports = __webpack_public_path__ + "static/media/xhh.e8fe8c62.svg";